import { Box } from '@material-ui/core';
import { Skeleton } from '@material-ui/lab';
import { useEffect, useState } from 'react';
import { RouteComponentProps } from 'react-router-dom';
import { useAppDispatch, useAppSelector } from '../redux/hooks';
import { fetchGroups, fetchPodcasts } from '../utils/api';
import PodcastForm from './PodcastForm';

type PodcastProps = RouteComponentProps<{ id: string }>;

const Podcast: React.FC<PodcastProps> = ({ match }) => {
  const [loading, setLoading] = useState(true);
  const { podcasts, loading: loadingPodcasts } = useAppSelector((state) => state.podcasts);
  const { groups, loading: loadingGroups } = useAppSelector((state) => state.groups);
  const dispatch = useAppDispatch();

  const podcastId = match.params.id;
  const isLoading = loading || loadingPodcasts || loadingGroups;

  useEffect(() => {
    if (podcasts.length === 0) {
      fetchPodcasts(dispatch);
    }

    if (groups.length === 0) {
      fetchGroups(dispatch);
    }

    setLoading(false);
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  return (
    <div className="w-full border mx-auto p-4">
      {isLoading && (
        <>
          <Box width="300px" mb={2}>
            <Skeleton variant="rect" animation="wave" component="h5" />
          </Box>
          <>
            {Array.from({ length: 15 }).map((_, index) => (
              <div className="flex items-center mb-2" key={index}>
                <Box width="100px">
                  <Skeleton variant="rect" animation="wave" component="h5" />
                </Box>
                <Box width="700px">
                  <Skeleton variant="rect" animation="wave" component="h5" />
                </Box>
              </div>
            ))}
          </>
        </>
      )}
      {!isLoading && <PodcastForm podcasts={podcasts} groups={groups} id={podcastId} />}
    </div>
  );
};

export default Podcast;
